/**
 * Tragingview seems to persist some data.
 * This function will try to wipe all those from local storage
 */
export const wipeChartDefaultPersistedItems = () => {
  localStorage.removeItem('tv.logger.logHighRate');
  localStorage.removeItem('tvlocalstorage.available');
  localStorage.removeItem('tv.logger.loglevel');
  localStorage.removeItem('tvxwevents.settings');
  localStorage.removeItem('tvxwevents.FAVORITE_INTERVALS_CHANGED');
};
